export const MENUITEMS = [
  {
    menutitle: "Generals",
    menucontent: "Generals",
    Items: [
      {
        path: `/dashboard`,
        type: "link",
        title: "Dashboard",
        icon: "user",
      },
      {
        path: `/orders`,
        type: "link",
        title: "Orders",
        icon: "user",
      },
      {
        path: `/zips`,
        type: "link",
        title: "ZIPS",
        icon: "user",
      },
      {
        path: `/tasks`,
        type: "link",
        title: "Tasks",
        icon: "user",
      },

    ],
  },
  {
    menutitle: "Application",
    menucontent: "Application",
    Items: [

      {
        path: `/users/all-customers`,
        type: "link",
        title: "Users",
        icon: "user",
      },
      {
        path: `/users/all-block-customers`,
        type: "link",
        title: "Blocked Users",
        icon: "user",
      },

      {
        icon: "faq",
        type: "sub",
        title: "Admins",
        children: [


          {
            path: `/create-admin`,
            type: "link",
            title: "Create Admin",
          },
          {
            path: `/admin`,
            type: "link",
            title: "Admins",
          },
          {
            path: `/block-subAdmins`,
            type: "link",
            title: "Block SubAdmins",
          },
        ],
        
      },
      {
        path: `/tutorials`,
        type: "link",
        title: "Upload Vedios Tutorials",
        icon: "user",
      },
      {
        path: `/terms`,
        type: "link",
        title: "Terms and Conditions",
        icon: "user",
      },
      {
        path: ``,
        type: "link",
        title: "Logout",
      },
    ],
  },
];
